var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditWarning(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.0958 13.75H37.9042L13.75 37.9042V72.0958L37.9042 96.25H72.0958L96.25 72.0958V37.9042L72.0958 13.75ZM87.0833 68.2917L68.2917 87.0833H41.7083L22.9167 68.2917V41.7083L41.7083 22.9167H68.2917L87.0833 41.7083V68.2917Z",
    fill: "#2B3E5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9993 77.9167C57.5307 77.9167 59.5827 75.8646 59.5827 73.3333C59.5827 70.802 57.5307 68.75 54.9993 68.75C52.468 68.75 50.416 70.802 50.416 73.3333C50.416 75.8646 52.468 77.9167 54.9993 77.9167Z",
    fill: "#FFA000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.416 32.083H59.5827V64.1663H50.416V32.083Z",
    fill: "#FFA000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWarning);
export default __webpack_public_path__ + "static/media/editWarning.5dc29724b824f8291312255a83a0f2b0.svg";
export { ForwardRef as ReactComponent };